import { render, staticRenderFns } from "./BoundLabel.vue?vue&type=template&id=80214db4&lang=pug&"
import script from "./BoundLabel.vue?vue&type=script&lang=js&"
export * from "./BoundLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports